/**
 * On-Demand FBJS (Funnelback Search Client) Script Loader
 * Dynamically loads fbjsv2-9-10.js only when a listing or search container exists in the DOM.
 */

let fbjsPromise = null;

export const loadFbjsScript = () => {
    if (typeof window !== "undefined" && window.Search) {
        if (typeof window._hookSearchPrototype === "function") {
            window._hookSearchPrototype();
        }
        return Promise.resolve(window.Search);
    }

    if (fbjsPromise) {
        return fbjsPromise;
    }

    fbjsPromise = new Promise((resolve, reject) => {
        const isLocal =
            typeof window !== "undefined" &&
            (window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1");

        const scriptUrl =
            (typeof window !== "undefined" && window.FBJS_SCRIPT_URL) ||
            (isLocal
                ? "/externals/fbjs.js"
                : "https://www.woodgroup.com/__data/assets/js_file/0022/266026/fbjsv2-9-10.js");

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = scriptUrl;

        script.onload = () => {
            if (typeof window !== "undefined" && window.Search) {
                if (typeof window._hookSearchPrototype === "function") {
                    window._hookSearchPrototype();
                }
                resolve(window.Search);
            } else {
                reject(new Error("FBJS script loaded but window.Search is undefined"));
            }
        };

        script.onerror = (err) => {
            fbjsPromise = null; // Allow retry on failure
            reject(err);
        };

        document.head.appendChild(script);
    });

    return fbjsPromise;
};

export default loadFbjsScript;
